import React from 'react';

import NextImage from 'next/image';

import sunIconGray from './assets/sunIconGray.svg';

export interface ITemperatureIconProps {
  height?: number;
  width?: number;
}

const DEFAULT_SIZE = 32;

export const WeatherConditionIconGrey = ({
  height = DEFAULT_SIZE,
  width = DEFAULT_SIZE,
}: ITemperatureIconProps) => {
  return <NextImage alt="Sun Icon grey" width={width} height={height} src={sunIconGray} />;
};
